import React from 'react'
import { styled, Grid as GridBase } from '@mui/material'
import { Phone as BasePhoneIcon, PhoneAndroid as BasePhoneAndroidIcon, Help as BaseHelpIcon } from '@mui/icons-material'

export const FooterArea = styled('div')`
  background-color: ${props => props.theme.palette.brand.white};
  max-height: 178px;
  padding: 49px 38px 49px 38px;
  z-index: auto;
  ${props => props.theme.breakpoints.down('lg')} {
    min-height: 184px;
    max-height: inherit;
    padding: 40px 38px;
  }
`

export const GridContainer = styled(props => <GridBase {...props} container />)``

export const GridItem = styled(props => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    padding: ${props => props.padding || '0'};
    ${props => props.theme.breakpoints.down('sm')} {
      text-align: center;
      justify-content: center;
    }
  }
`

export const GridSeparator = styled(props => <GridBase {...props} item />)`
  &.MuiGrid-item {
    border-bottom: 1px solid ${props => props.theme.palette.brand.gray1};
    margin-bottom: 24px;
    padding-top: 10px;
    ${props => props.theme.breakpoints.down('lg')} {
      margin-bottom: 0px;
      padding: 0;
    }
  }
`

export const LinkContainer = styled(props => <GridContainer {...props} />)`
  &.MuiGrid-container {
    ${props => props.theme.breakpoints.down('lg')} {
      padding-top: 45px;
    }
    ${props => props.theme.breakpoints.down('sm')} {
      padding-top: 0;
    }
  }
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  line-height: 14.06px;
  text-align: left;
  text-decoration: underline;

  &:active,
  &:focus,
  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const NumberLink = styled(Link)`
  color: ${props => props.theme.palette.brand.black1};
  text-decoration: none;
`

export const PhoneIcon = styled(BasePhoneIcon)`
  color: ${props => props.theme.palette.brand.black2};
  height: 24px;
  width: 24px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const CustomPhoneIcon = styled('img')`
  height: 24px;
  width: 24px;

  ${props => props.theme.breakpoints.down('lg')} {
    padding: 0 0 5px;
  }
`

export const PhoneAndroidIcon = styled(BasePhoneAndroidIcon)`
  color: ${props => props.theme.palette.brand.black2};
  height: 24px;
  width: 24px;

  ${props => props.theme.breakpoints.down('lg')} {
    padding: 0 0 5px;
  }

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const HelpIcon = styled(BaseHelpIcon)`
  color: ${props => props.theme.palette.brand.black2};
  height: 24px;
  width: 24px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`
